interface useCountMaxTagsProps {
  nbMax?: number;
  tagList: any[];
}

function useCountMaxTags(props: useCountMaxTagsProps) {
  const { nbMax = 2, tagList = [] } = props;

  const visibleTags = nbMax && tagList.length > nbMax ? tagList.slice(0, nbMax) : tagList;
  const hiddenTagsCount = tagList.length - visibleTags.length;

  return {
    visibleTags,
    hiddenTagsCount,
  };
}

export default useCountMaxTags;
